import React, { useMemo } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { ReportingShellContainerBaseConfig } from '../../../base';
import { ChatOverlayContainerProps, ChatOverlayViewProps } from './chatOverlayProps';
import { ChatOverlayController, ChatOverlayLoader } from './chatOverlayInterface';
import { z } from 'zod';
import { useParams } from 'react-router';

export function createChatOverlayContainer(
    config: ReportingShellContainerBaseConfig,
    loader: ChatOverlayLoader,
    controller: ChatOverlayController,
    View: React.FC<ChatOverlayViewProps>
): React.FC<ChatOverlayContainerProps> {
    const {
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
        context: { useContext },
        pubsub: {
            router: { useHandler },
        },
    } = config;

    const UrlParamSchema = z.object({
        contentId: z.string(),
    });

    return config.state.chat.subscribe(
        ({ minWidth, maxWidth, initialWidth, ...containerProps }) => {
            const context = useContext();
            const state = config.state.chat.useState(context);
            const layoutState = config.state.layout.useState(context);
            const params = useParams();
            const options = useMemo(() => {
                return UrlParamSchema.safeParse(params);
            }, [params]);

            // const pubsub = useHandler(context, {
            //     onEvent(event) {
            //         if (event.kind === 'ask') {
            //             console.log('open chat overlay');
            //             state.onChange({ ...state.value, isOpen: true });
            //             return;
            //         }
            //         if (event.kind === 'analyze') {
            //             console.log('analyze');
            //             state.onChange({ thread: null, isOpen: true });
            //             return;
            //         }
            //     },
            // });

            const data = loader.useLoad(context, containerProps);
            const props = controller.useProps(context, data, {
                content: options.data?.contentId
                    ? {
                          id: options.data.contentId,
                      }
                    : null,
                minWidth,
                maxWidth,
                initialWidth,
                width: {
                    value: layoutState.value.chatWidth,
                    onChange(value) {
                        layoutState.onChange({
                            ...layoutState.value,
                            chatWidth: value,
                        });
                    },
                },
                overlay: {
                    disclosure: useDisclosure({
                        isOpen: state.value.isOpen,
                        onOpen: () => {
                            state.onChange({ ...state.value, isOpen: true });
                        },
                        onClose: () => {
                            state.onChange({ ...state.value, isOpen: false });
                        },
                    }),
                },
                thread: state.value.thread
                    ? {
                          id: state.value.thread,
                      }
                    : null,
            });

            return <View {...props} />;
        }
    );
}
